var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-tutorial", { attrs: { steps: _vm.steps } }, [
    _c("div", [
      _c("h2", [_vm._v("Olá! Vamos começar sua autoavaliação técnica?")]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Analise as suas responsabilidades")]),
      _c("p", [
        _vm._v(
          " As responsabilidades que aparecerão na sua tela foram consolidadas na etapa “Mapeamento Técnico”. Ao lado de cada responsabilidade, aparecerá uma escala que vai de "
        ),
        _c("span", { staticClass: "info--text" }, [_vm._v('"Não executou"')]),
        _vm._v(" a "),
        _c("span", { staticClass: "info--text" }, [_vm._v('"Excelente"')]),
        _vm._v(". "),
      ]),
      _c("p", [
        _vm._v(
          " Lembre-se que compete ao gestor todas as responsabilidades da unidade. "
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v("Analise a forma de execução das suas responsabilidades"),
      ]),
      _c("p", [
        _vm._v(
          " Clique na estrela que representa a forma que você executou a responsabilidade indicada durante os últimos doze meses. "
        ),
      ]),
      _c("p", [
        _vm._v(" Ao utilizar o "),
        _c("span", { staticClass: "info--text" }, [_vm._v('"Não executou"')]),
        _vm._v(
          " você está indicando que a responsabilidade é sua, porém não a executou nos últimos 12 meses. "
        ),
      ]),
      _c("p", [
        _vm._v(
          " Atenção! As responsabilidades delegadas à sua equipe continuam sob sua competência, ou seja, o que for executado por sua equipe, indiretamente, foi executado por você. "
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Importante!")]),
      _c("p", { staticClass: "info--text" }, [
        _vm._v(
          " Lembre-se! Essa autoavaliação ajudará a direcionar sua trilha de desenvolvimento. "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }